import { ModalContainer, PopupContainer } from "@ascend-ltd/design-kit";
import type { AppProps } from "next/app";
import dynamic from "next/dynamic";
import Head from "next/head";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../assets/styles.scss";
import { ErrorBoundary } from "../components/error-boundary";
import { setup } from "../setup";

// AuthKitがサーバサイドでは使用できないため, dynamic importする
const AuthContextProvider = dynamic(
  () => import("../components/contexts/auth-context-provider"),
  { ssr: false }
);

function Accounts({ Component, pageProps }: AppProps) {
  setup();
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Ascend Accounts</title>
      </Head>
      <ErrorBoundary>
        <AuthContextProvider>
          <Component {...pageProps} />
        </AuthContextProvider>
        <ModalContainer />
        <PopupContainer />
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          theme="light"
          pauseOnHover
          pauseOnFocusLoss
          closeOnClick
        />
      </ErrorBoundary>
    </>
  );
}

export default Accounts;
